// Take a string in teh form '11 22 33' and return the converted hex
export function rgbToHex(rgb) {
  const [r, g, b] = rgb.split(' ').map((c) => parseInt(c));
  // If the hex is missing a trailing 0, add it

  if (!r || !g || !b) {
    console.warn('Invalid RGB', rgb, 'returning black');
    return '#000000';
  }

  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}